import analytics from '../../analytics';
import { TAB_SHOW_EVENT } from '../tabs';
const getTracking = () => JSON.parse(document.querySelector('[data-tracking]').dataset.tracking);
export default () => {
    document.querySelectorAll('[role="tabpanel"]').forEach((tabPanel) => {
        tabPanel.addEventListener(TAB_SHOW_EVENT, (event) => {
            const tabId = event.detail.id;
            if (tabId === 'tab-panel-product-details') {
                analytics.productTabDetail(getTracking());
            }
        });
    });
};
